import React from "react";
import { RiArrowDownSLine } from "react-icons/ri";

import './section-two.css';

const SectionTwo = () => {
  return (
    <section className="sectionTwo__container">
      <div className="sectioTwo__content content__page">
        <div className="top__content-st">
          <p>
            Comemorações dos 215 anos da Abertura da Barra do Porto de Aveiro
          </p>
        </div>
        <div className="arrow content__page">
          <a href="#program" rel="noreferrer" className="arrow-down">
            <RiArrowDownSLine />
          </a>
        </div>
        <div className="content__middle-st">
          <div className="text__content-st">
            <p>
            "O dia trez de Abril deste prezente anno foi o venturoso dia d’Abertura da Nova barra de Aveiro; elle foi, em certo modo, hum segundo dia de creação em que se operou, como por um prodígio, hua conveniente e necessária separação das agoas, e dos terrenos, que estavão na mais fatal confusão: E este Grande Beneficio, que V.A.R. preparava a estes Povos desde muito tempo, fez despertar, como eu fui testemunha, a saudade constante que os Povos mais interessados nesta Obra consagravam ao seu Legitimo Auzente Soberan quando gemia debaixo da escravidão e tyrania de que o Ceo, auxiliando os nossos próprios exforsos, e os dos nossos amigos, acaba de resgatar-nos."
              <br />
              <br />
              
              <small>Trecho de carta Luís Gomes de Carvalho a D. Rodrigo de Sousa Coutinho, de 30 de setembro de 1808.</small>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionTwo;
